import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    projectType: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, you would send this data to a backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        projectType: '',
        message: ''
      });
    }, 3000);
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">
            Ready to get started? Call us today for a digital meeting or phone call to discuss your project.
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-section">
              <h2>Get Your Proposal</h2>
              <p className="form-intro">
                Fill out the form below and we'll get back to you with a detailed proposal, schedule, and pricing for your project.
              </p>
              
              {submitted ? (
                <div className="success-message">
                  <img src="/icons/TB_Icons_Arrow-Right.png" alt="Success" className="success-icon" />
                  <h3>Thank You!</h3>
                  <p>We've received your message and will get back to you soon.</p>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="John Doe"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="john@example.com"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Phone Number *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="(555) 123-4567"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="projectType">Project Type *</label>
                    <select
                      id="projectType"
                      name="projectType"
                      value={formData.projectType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select a project type</option>
                      <option value="residential">Residential</option>
                      <option value="commercial">Commercial</option>
                      <option value="both">Both</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Project Details *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="6"
                      placeholder="Please provide details about your project, including site location, scope of work, and any specific requirements..."
                    />
                  </div>

                  <button type="submit" className="btn-primary btn-submit">
                    Submit Request
                  </button>
                </form>
              )}
            </div>

            {/* Contact Info */}
            <div className="contact-info-section">
              <div className="info-card">
                <h2>Get in Touch</h2>
                <p className="info-description">
                  We're ready to provide proposals, schedules, and pricing for your approved architectural construction documents.
                </p>

                {/* Contact Information */}
                <div className="contact-info-box">
                  <h3>Contact Information</h3>
                  <div className="contact-info-item">
                    <img src="/icons/TB_Icons_Truck 2.png" alt="Phone" className="contact-info-icon" />
                    <div>
                      <h4>Phone</h4>
                      <p><a href="tel:6174126800">(617) 412-6800</a></p>
                    </div>
                  </div>
                  <div className="contact-info-item">
                    <img src="/icons/TB_Icons_Hardhat.png" alt="Email" className="contact-info-icon" />
                    <div>
                      <h4>Email</h4>
                      <p><a href="mailto:info@tbconstructionco.com">info@tbconstructionco.com</a></p>
                    </div>
                  </div>
                  <div className="contact-info-item">
                    <img src="/icons/TB_Icons_Caution Barrier.png" alt="Location" className="contact-info-icon" />
                    <div>
                      <h4>Location</h4>
                      <p>Greater Boston Area</p>
                    </div>
                  </div>
                </div>

                <div className="info-item">
                  <img src="/icons/TB_Icons_Hardhat.png" alt="Experience" className="info-icon" />
                  <div>
                    <h3>Experience</h3>
                    <p>Over 30 years of experience</p>
                  </div>
                </div>

                <div className="info-item">
                  <img src="/icons/TB_Icons_Hardhat.png" alt="Info" className="info-icon" />
                  <div>
                    <h3>Services</h3>
                    <p>Residential & Commercial Applications</p>
                  </div>
                </div>

                <div className="requirements-box">
                  <h3>What We Need</h3>
                  <p>Clients provide approved architectural construction documents that are fully approved by the building department and/or local zoning board.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;

